<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="$emit('close')">
    <div class="bg-white rounded-lg p-6 max-w-2xl w-full">
      <div class="flex justify-between items-start mb-4">
        <h2 class="text-xl font-bold">Scheduled Call Details</h2>
        <button @click="$emit('close')" class="text-gray-500 hover:text-gray-700">
          <XMarkIcon class="w-6 h-6" />
        </button>
      </div>
      
      <div class="space-y-4">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <span class="text-sm text-gray-500">Profile:</span>
            <span class="ml-2 font-medium">{{ call.profile?.name || 'Unknown' }}</span>
          </div>
          <div>
            <span class="text-sm text-gray-500">Scheduled Time:</span>
            <span class="ml-2">{{ formatDateTime(call.scheduled_time) }}</span>
          </div>
          <div>
            <span class="text-sm text-gray-500">Status:</span>
            <span :class="['ml-2 badge', getStatusClass(call.status)]">{{ call.status }}</span>
          </div>
          <div>
            <span class="text-sm text-gray-500">Repeat:</span>
            <span class="ml-2">{{ call.repeat || 'No repeat' }}</span>
          </div>
        </div>
        
        <div class="flex justify-end space-x-2">
          <button @click="$emit('reschedule', call)" class="btn btn-secondary">
            Reschedule
          </button>
          <button @click="$emit('cancel', call)" class="btn btn-danger">
            Cancel Call
          </button>
          <button @click="$emit('close')" class="btn btn-primary">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { XMarkIcon } from '@heroicons/vue/24/outline'
import dayjs from 'dayjs'

defineProps({
  call: {
    type: Object,
    required: true
  }
})

defineEmits(['close', 'reschedule', 'cancel'])

function formatDateTime(datetime) {
  return dayjs(datetime).format('MMM DD, YYYY h:mm A')
}

function getStatusClass(status) {
  const classes = {
    scheduled: 'badge-info',
    active: 'badge-success',
    cancelled: 'badge-danger'
  }
  return classes[status] || 'badge-secondary'
}
</script>